import { axios } from "../utils/axios";
import { AxiosError, isAxiosError } from "axios";
import { toast } from "react-toastify";
import { useGeneralAppStore } from "../store/generalAppStore";
import { toastOptions } from "../config/toast";
import { useActasStore } from "../store/actasStore";
import { useActaDetalleStore } from "../store/actaDetalleStore";
import { useFilterActas } from "../store/filterActasStore";

const useActas = () => {
  const {
    actas,
    setActas,
    setLocalidades,
    setTipos,
    setCp,
    actasFilter,
    setActasFilter,
    codigosZonales,
    setCodigosForaneos,
    setActaDetalle,
    setActasDetalle,
    actasDetalle,
    setActasBuscadas,
    setReplaceActasDetalle,
    setEstadoBuscado,
  } = useActasStore();
  const {
    setAllActaDetalle,
    acta,
    coleccionActasDetalle,
    setColeccionActasDetalle,
    setActa,
    actaDetalle,
    setArchivosActas,
    setArchivos,
    archivos,
  } = useActaDetalleStore();

  const { setFilterFields } = useFilterActas();
  const { handlerLoading, handlerModal, modals } = useGeneralAppStore();

  //TRAE TODA MIS DECLARACIONES
  const getActas = async (path) => {
    handlerLoading({ loading: true, loadName: "actas" });
    const response = await axios().get(path);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        if (path == "reportes_notificadores") {
          data.map(
            (d) =>
              (d.fecha_reporte = d.fecha_no_notificado
                ? d.fecha_no_notificado
                : d.fecha_notificacion
                  ? d.fecha_notificacion
                  : null)
          );
        }
        setActas(
          data.sort((a, b) => parseInt(b.numero_acta) - parseInt(a.numero_acta)).slice(0, 10)
        );
        setActasFilter(
          data.sort((a, b) => parseInt(b.numero_acta) - parseInt(a.numero_acta)).slice(0, 10)
        );
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "actas" });
  };

  //QUITAR NOTIFICADOR A ACTA ASIGNADA
  const quitarNotificadorAsignado = async (dataSend, setRefetch = null) => {
    handlerLoading({ loading: true, loadName: "desasignar_notificador" });
    const response = await axios().post("quitar_notificador_asignado", dataSend);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        setColeccionActasDetalle(
          coleccionActasDetalle.map((acta) => {
            if (acta.acta.id == data.id) {
              acta.acta = data;
            }
            return acta;
          })
        );

        if (actas) {
          setActa(data);
          const newActas = actas.filter((acta) => acta.id != data.id);
          setActas(newActas);
          const newActasFilter = actasFilter.filter((acta) => acta.id != data.id);
          setActasFilter(newActasFilter);
        }

        if (actaDetalle) {
          setAllActaDetalle({ acta: data, archivos: actaDetalle?.archivos });
        }

        modals.includes("modal_desasignar_acta") &&
          handlerModal({ modal: false, modalName: "modal_desasignar_acta" });
        modals.includes("desasignar_notificador") &&
          handlerModal({ modal: false, modalName: "desasignar_notificador" });
        setRefetch && setRefetch(true);
        toast.success("Se desasigno el notificador del acta", toastOptions);
      }

      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "desasignar_notificador" });
  };

  //ASIGNAR ACTAS A UN NOTIFICADOR
  const asignarActasANotificador = async (dataSend, setActasAsignar = null, setRefetch = null) => {
    handlerLoading({ loading: true, loadName: "asignar_notificador" });
    const response = await axios().post("asignar_notificador", dataSend);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        let pepito = coleccionActasDetalle.map((obj) => {
          if (dataSend.actas.includes(obj.acta.id)) {
            let actita = data.actas.filter((act, index) => {
              if (act.id == obj.acta.id) {
                return data.actas[index].acta;
              }
            });
            return { acta: actita[0].acta, archivos: obj.archivos };
          } else {
            return obj;
          }
        });

        setColeccionActasDetalle(pepito);

        if (actas) {
          const newActas = actas.filter((acta) => {
            if (acta != undefined && dataSend.actas.includes(acta.id) == false) {
              return acta;
            }
          });

          const newActasFilter = actasFilter.filter((acta) => {
            if (acta != undefined && dataSend.actas.includes(acta.id) == false) {
              return acta;
            }
          });
          setActas(newActas);
          setActasFilter(newActasFilter);
        }
        // console.log("entre");
        // console.log(data.actas[0].acta);
        // console.log(actaDetalle);
        // console.log(acta);
        if (actaDetalle) {
          setAllActaDetalle({ acta: data.actas[0].acta, archivos: actaDetalle?.archivos });
        }

        if (setActasAsignar) {
          setActasAsignar([]);
        }
        toast.success("Se asignaron actas al notificador", toastOptions);

        setRefetch && setRefetch(true);
        if (modals.includes("notificadores")) {
          handlerModal({ modal: false, modalName: "notificadores" });
        }
      }

      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "asignar_notificador" });
  };

  //TRAE EL DETALLE DE UN ACTA
  const getActaDetalle = async (id, search = false) => {
    handlerLoading({ loading: true, loadName: "acta_detalle" });
    const response = await axios().get(`acta/${id}`);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        setAllActaDetalle(data);
        setActaDetalle(data);
        setActasDetalle(data);
        if (!search) {
          handlerModal({ modal: true, modalName: "acta_detalle" });
        } else {
          setActasBuscadas(data);
        }
      }

      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "acta_detalle" });
  };

  const getActaChequear = async (dataSend) => {
    handlerLoading({ loading: true, loadName: "acta_detalle" });
    const response = await axios().get(`acta_a_chequear/${dataSend}`);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        // setActaDetalle(data);
        setAllActaDetalle(data);
        // setActasDetalle(data);
        handlerModal({ modal: true, modalName: "acta_detalle" });
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "acta_detalle" });
  };

  const marcarActaImpresa = async (dataSend, setRefetch = null) => {
    // console.log(dataSend);
    handlerLoading({ loading: true, loadName: "marcar_impresa" });
    handlerLoading({ loading: true, loadName: "impresa_acta_detalle" });
    const response = await axios().post("fecha_impresion", dataSend);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        if (actaDetalle) {
          setAllActaDetalle(data);
        }
        // setActa(data.acta);
        const newColeccionActasDetalle = coleccionActasDetalle.map((acta) => {
          if (acta.acta.id == data.acta.id) {
            acta.acta = data.acta;
          }
          return acta;
        });
        setColeccionActasDetalle(newColeccionActasDetalle);
        const newActas = actas?.filter((acta) => acta.id != data.acta.id);
        setActas(newActas);
        const newActasFilter = actasFilter?.filter((acta) => acta.id != data.acta.id);
        setActasFilter(newActasFilter);
        handlerModal({ modal: false, modalName: "marcar_impresa" });
        handlerModal({ modal: false, modalName: "impresa_acta_detalle" });
        setRefetch && setRefetch(true);
        toast.success("El acta impresa correctamente", toastOptions);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un erro en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "marcar_impresa" });
    handlerLoading({ loading: false, loadName: "impresa_acta_detalle" });
  };

  const cambiarEstadoDescargo = async (dataSend, setRefetch = null) => {
    handlerLoading({ loading: true, loadName: "descargo" });
    try {
      const response = await axios().post("cambiar_estado_descargo", dataSend);
      const { data, error } = response.data;
      if (error) {
        toast.error(error, toastOptions);
      } else {
        setActa(data);
        setColeccionActasDetalle(
          coleccionActasDetalle.map((acta) => {
            if (acta.acta.id == data.id) {
              acta.acta = data;
            }
            return acta;
          })
        );
        if (actas) {
          const newActas = actas.filter((acta) => acta.id != dataSend.id);
          setActas(newActas);
          const newActasFilter = actasFilter.filter((acta) => acta.id != dataSend.id);
          setActasFilter(newActasFilter);
        }
        toast.success("Cambios guardados correctamente", toastOptions);
        setRefetch(true);
        handlerModal({ modal: false, modalName: "descargo" });
      }
    } catch (error) {
      toast.error("Hubo un erro en la consulta", toastOptions);
    } finally {
      handlerLoading({ loading: false, loadName: "descargo" });
    }
  };

  const buscarActa = async (dataSend, path = null, setEstado = null) => {
    handlerLoading({ loading: true, loadName: "buscar_acta" });
    let result;

    result = await axios().post("buscar_acta", dataSend);

    if (!isAxiosError(result)) {
      const { data, error } = result.data;
      // console.log(data)
      if (data && !error) {
        if (dataSend.datos_sobre == "numero_acta") {
          setAllActaDetalle(data);
          setActaDetalle(data);
          setActasDetalle(data);
          setActasBuscadas(data);
        }
        if (dataSend.datos_sobre == "plate" || dataSend.datos_sobre == "documento") {
          setActas(data);
        }
        if (dataSend.datos_sobre == "estado") {
          // console.log(data)
          if (path == "/gestion_actas") {
            if (setEstado) {
              setEstado(data?.acta?.estado_id);
              setFilterFields("numero_acta", dataSend?.valor);
            }
          } else {
            setEstadoBuscado(data && data?.acta?.estado_id);
          }
        }
      }

      if (!data && error) {
        // for (const key in error) {
        //   error[key]?.forEach((mensaje) => {
        //     toast.error(mensaje, toastOptions);
        //   });
        //   }
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta");
    }
    handlerLoading({ loading: false, loadName: "buscar_acta" });
  };

  const anularActa = async (dataSend, setRefetch) => {
    handlerLoading({ loading: true, loadName: "modal_confirm" });
    try {
      const response = await axios().post("anular_acta", dataSend);
      const { data, error } = response.data;
      if (error) {
        toast.error(error, toastOptions);
        return;
      }
      setAllActaDetalle(data);
      const newActas = actas?.filter((acta) => acta.id != data.acta.id);
      setActas(newActas);
      const newActasFilter = actasFilter?.filter((acta) => acta.id != data.acta.id);
      setActasFilter(newActasFilter);
      setRefetch && setRefetch(true);
      toast.success("El acta fue anulada correctamente", toastOptions);
      handlerModal({ modal: false, modalName: "modal_confirm" });
      handlerModal({ modal: false, modalName: "acta_detalle" });
    } catch (error) {
      toast.error("Hubo un error en la consulta", toastOptions);
    } finally {
      handlerLoading({ loading: false, loadName: "modal_confirm" });
    }
    // handlerLoading({ loading: true, loadName: "modal_confirm" });
    // const response = await axios().post("anular_acta", dataSend);
    // if (!isAxiosError(response)) {
    //   const { data, error } = response.data;
    //   if (data && !error) {
    //     setAllActaDetalle(data);
    //     const newActas = actas?.filter((acta) => acta.id != data.acta.id);
    //     setActas(newActas);
    //     const newActasFilter = actasFilter?.filter((acta) => acta.id != data.acta.id);
    //     setActasFilter(newActasFilter);
    //     handlerModal({ modal: false, modalName: "modal_confirm" });
    //     setRefetch && setRefetch(true);
    //     toast.success("El acta fue anulada correctamente", toastOptions);
    //   }
    //   if (!data && error) {
    //     toast.error(error, toastOptions);
    //   }
    // } else {
    //   toast.error("Hubo un error en la consulta", toastOptions);
    // }
    // handlerLoading({ loading: false, loadName: "modal_confirm" });
  };

  const notificarActaDigital = async (dataSend, setRefetch) => {
    handlerLoading({ loading: true, loadName: "modal_notificar_digital" });
    const response = await axios().post("notificar_digital", dataSend);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        // setAllActaDetalle(data);
        // const newActas = actas?.filter((acta) => acta.id != data.acta.id);
        // setActas(newActas);
        // const newActasFilter = actasFilter?.filter((acta) => acta.id != data.acta.id);
        // setActasFilter(newActasFilter);
        setRefetch && setRefetch(true);
        handlerModal({ modal: false, modalName: "modal_notificar_digital" });
        toast.success("El acta fue notificada correctamente", toastOptions);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "modal_notificar_digital" });
  };
  const notificarActa = async (dataSend) => {
    handlerLoading({ loading: true, loadName: "modal_notificar_acta" });
    const response = await axios().post("notificar_acta", dataSend);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        // setAllActaDetalle(data);
        // const newActas = actas?.filter((acta) => acta.id != data.acta.id);
        // setActas(newActas);
        // const newActasFilter = actasFilter?.filter((acta) => acta.id != data.acta.id);
        // setActasFilter(newActasFilter);
        handlerModal({ modal: false, modalName: "modal_notificar_acta" });
        toast.success("El acta fue notificada correctamente", toastOptions);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "modal_notificar_acta" });
  };

  const imprimirActas = async (dataSend, setActasAImprimir) => {
    handlerLoading({ loading: true, loadName: "actas_a_imprimir" });
    const response = await axios().post("actas_a_imprimir", dataSend);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        let pepito = coleccionActasDetalle.map((obj) => {
          if (dataSend.actas.includes(obj.acta.id)) {
            let actita = data.filter((act, index) => {
              if (act.id == obj.acta.id) {
                return data[index];
              }
            });
            return { acta: actita[0], archivos: obj.archivos };
          } else {
            return obj;
          }
        });

        setColeccionActasDetalle(pepito);
        const newActas = actas.filter((acta) => {
          if (dataSend.actas.includes(acta.id) == false) {
            return acta;
          }
        });

        const newActasFilter = actasFilter.filter((acta) => {
          if (dataSend.actas.includes(acta.id) == false) {
            return acta;
          }
        });
        const newActasDetalle = actasDetalle.filter((actaDetalle) => {
          if (dataSend.actas.includes(actaDetalle?.acta.id) == false) {
            return actaDetalle;
          }
        });
        setActasDetalle(newActasDetalle);
        setActas(newActas);
        setActasFilter(newActasFilter);
        setActasAImprimir([]);
        toast.success("Se imprimieron actas correctamente", toastOptions);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "actas_a_imprimir" });
  };

  const generarActa = async (setPdf) => {
    handlerLoading({ loading: true, loadName: "generar_acta" });
    const response = await axios().post("generar_acta", {
      numero_infraccion: actaDetalle.acta.numero_infraccion,
      tipo: "fisica",
    });
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        const actaFisica = actaDetalle?.archivos?.actas?.filter(
          (acta) => acta.tipo_acta === "fisica"
        );
        if (actaFisica?.length === 0 || typeof actaFisica == "undefined") {
          const base64Length = data.archivo.file.length;
          const base64SizeInMB = (base64Length * 3) / 4 / (1024 * 1024);
          let actasArray = [];
          if (Array.isArray(actaDetalle?.archivos?.actas)) {
            actasArray = actaDetalle.archivos.actas;
          }
          const actas = [
            ...actasArray,
            {
              ...data.archivo,
              es_pesada: base64SizeInMB > 5 ? true : false,
              tipo_acta: "fisica",
            },
          ];
          // console.log(actas);
          setArchivos({ ...actaDetalle.archivos, actas: actas });
        }

        setColeccionActasDetalle(
          coleccionActasDetalle.map((acta) => {
            if (acta.acta.id == data.acta.id) {
              acta.acta = data.acta;
            }
            return acta;
          })
        );
        // console.log(data.data)
        // console.log(actaDetalle)
        // setArchivosActas(data.archivo);
        setActa(data.acta);
        setPdf(data.archivo.file);
        const newActas = actas.filter((acta) => acta.id != data.acta.id);
        setActas([...newActas, data.acta]);
        const newActasFilter = actasFilter.filter((acta) => acta.id != data.acta.id);
        setActasFilter([...newActasFilter, data.acta]);
        const newActasDetalle = actasDetalle.filter((acta) => acta.acta.id != data.acta.id);
        setReplaceActasDetalle(newActasDetalle);
      }
      if (!data && error) {
        if (response.status !== 422) {
          toast.error(error.general, toastOptions);
        } else {
          Object.values(error).map((err) => toast.error(err, toastOptions));
        }
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "generar_acta" });
  };

  const completarDatosDomicilio = async (dataSend, setRefetch = null) => {
    // console.log(actaDetalle)
    // console.log(dataSend)
    // handlerLoading({ loading: true, loadName: "completar_datos" });
    handlerLoading({ loading: true, loadName: "editar_acta" });

    const response = await axios().post("completar_datos_domicilio", dataSend);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        // console.log(data)
        // setAllActaDetalle((prevState)=>({archivos:{...prevState.archivos,actas: data.archivos.actas, fotos_comprimidas:data.archivos.fotos_comprimidas, vide: data.archivos.video},acta: data.acta,}));
        setAllActaDetalle({
          acta: data.acta,
          archivos: {
            ...actaDetalle.archivos,
            video: data.archivos.video,
            fotos_comprimidas: data.archivos.fotos_comprimidas,
            actas: data.archivos.actas,
          },
        });
        // setActa(data.acta);
        setColeccionActasDetalle(
          coleccionActasDetalle.map((acta) => {
            if (acta.acta.id == data.acta.id) {
              acta = data;
            }
            // return acta;
            return {
              acta: data.acta,
              archivos: {
                ...actaDetalle.archivos,
                video: data.archivos.video,
                fotos_comprimidas: data.archivos.fotos_comprimidas,
                actas: data.archivos.actas,
              },
            };
          })
        );
        toast.success("Se completo el acta correctamente", toastOptions);
        setRefetch && setRefetch(true);
        handlerModal({ modal: false, modalName: "editar_acta" });
        handlerModal({ modal: false, modalName: "completar_datos" });
        const newActas = actas.filter((acta) => acta.id != dataSend.id);
        setActas(newActas);
        const newActasFilter = actasFilter.filter((acta) => acta.id != dataSend.id);
        setActasFilter(newActasFilter);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    // handlerLoading({ loading: false, loadName: "completar_datos" });
    handlerLoading({ loading: false, loadName: "editar_acta" });
  };

  const marcarActaComoIncompleta = async (setRefetch = null) => {
    handlerLoading({ loading: true, loadName: "acta_incompleta" });
    const response = await axios().post("acta_incompleta", { id_acta: acta?.id });
    const { status } = response;
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        // console.log(data)

        // setActaDetalle(data);
        setAllActaDetalle(data);
        // setActa({ ...acta, ...data.acta });

        // const newColeccionActasDetalle = coleccionActasDetalle.map((acta) => {
        //   if (acta.acta.id == data.acta.id) {
        //     acta.acta = data.acta;
        //   }
        //   return acta;
        // });
        // setColeccionActasDetalle(newColeccionActasDetalle);
        // const newActas = actas?.filter((acta) => acta.id != data.acta.id);
        // setActas(newActas);
        // const newActasFilter = actasFilter?.filter((acta) => acta.id != data.acta.id);
        // setActasFilter(newActasFilter);
        handlerModal({ modal: false, modalName: "incompleta_acta_detalle" });
        setRefetch && setRefetch(true);
        toast.success("Se marco el acta como incompleta correctamente", toastOptions);
      }

      if (!data && error) {
        if (status !== 422) {
          toast.error(error, toastOptions);
        } else {
          Object.values(error).map((err) => toast.error(err[0], toastOptions));
        }
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "acta_incompleta" });
  };

  const marcarActaComoAprobadoParaImprimir = async (dataSend, setRefetch) => {
    handlerLoading({ loading: true, loadName: "aprobada_imprimir" });
    const response = await axios().post("acta_aprobado_para_imprimir", dataSend);
    const { status } = response;
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        if (data?.acta?.estado_id == 17) {
          toast.success("El acta fue enviada a Doble Chequeo", toastOptions);
          setRefetch(true);
          handlerModal({ modal: false, modalName: "aprobada_imprimir" });
          if (modals.includes("acta_detalle")) {
            handlerModal({ modal: false, modalName: "acta_detalle" });
          }
        } else {
          setAllActaDetalle(data);
          // const newColeccionActasDetalle = coleccionActasDetalle.map((acta) => {
          //   if (acta.acta.id == data.acta.id) {
          //     acta.acta = data.acta;
          //   }
          //   return acta;
          // });
          // setColeccionActasDetalle(newColeccionActasDetalle);
          // const newActas = actas?.filter((acta) => acta.id != data.acta.id);
          // setActas(newActas);
          // const newActasFilter = actasFilter?.filter((acta) => acta.id != data.acta.id);
          // setActasFilter(newActasFilter);
          setRefetch(true);
          handlerModal({ modal: false, modalName: "aprobada_imprimir" });
          if (modals.includes("editar_acta")) {
            handlerModal({ modal: false, modalName: "editar_acta" });
          }
          toast.success("Se marco el acta como aprobada para imprimir", toastOptions);
        }
      }

      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "aprobada_imprimir" });
  };

  const generarConstancia = async (dataSend, setPdf) => {
    handlerLoading({ loading: true, loadName: "constancia" });
    const response = await axios().get("get_constancia_notificacion/" + dataSend);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        // console.log(data);
        setPdf(data);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "constancia" });
  };
  //CONSULTA EL ESTADO DE LA DECLARACION JURADA
  //   const consultarEstado = async (id) => {
  //     handlerLoading({ loading: true, loadName: "tabla" });
  //     const response = await axios().post("dj/consulta_estado_recibo", { dj_id: id });
  //     if (!isAxiosError(response.data)) {
  //       const { data, error } = response.data;
  //       if (data && !error) {
  //         // setReciboDj(data);
  //         if (typeof data != "object") {
  //           toast.success(data, toastOptions);
  //         } else {
  //           if (data.recibo.vencio == 1) {
  //             toast.error("El recibo vencio", toastOptions);
  //           }
  //           if (data.recibo.fecha_pago) {
  //             toast.success("El recibo esta pagado", toastOptions);
  //           } else {
  //             toast.success("El recibo no esta pagado", toastOptions);
  //           }
  //           let newDdjj = ddjj.map((dj) => {
  //             if (dj.id == data.id) {
  //               dj = data;
  //             }
  //             return dj;
  //           });
  //           setDdjj(newDdjj);
  //         }
  //       }
  //       if (!data && error) {
  //         if (error.includes("cURL")) {
  //           toast.error("Hubo un error obteniendo el estado del recibo", toastOptions);
  //         } else {
  //           toast.error(error, toastOptions);
  //         }
  //       }
  //     } else {
  //       toast.error("Hubo un error en la consulta", toastOptions);
  //     }
  //     handlerLoading({ loading: false, loadName: "tabla" });
  //   };

  //GENERAR RECIBO
  //   const generarRecibo = async (id) => {
  //     handlerLoading({ loading: true, loadName: "tabla" });
  //     const response = await axios().post("dj/generar_recibo", { dj_id: id });
  //     if (!isAxiosError(response.data)) {
  //       const { data, error } = response.data;
  //       if (data && !error) {
  //         const newDdjj = ddjj.map((dj) => {
  //           if (dj.id == data.id) {
  //             dj = data;
  //           }
  //           return dj;
  //         });
  //         setDdjj(newDdjj);
  //         setReciboDj(data);
  //         handlerModal({ modal: true, modalName: "pago" });
  //       }

  //       if (!data && error) {
  //         if (error.includes("cURL")) {
  //           toast.error("Hubo un error obteniendo el estado del recibo", toastOptions);
  //         } else {
  //           toast.error(error, toastOptions);
  //         }
  //       }
  //     } else {
  //       toast.error("Hubo un error en la consulta", toastOptions);
  //     }
  //     handlerLoading({ loading: false, loadName: "tabla" });
  //   };

  //GENERACION DE PDF DE LA CONSULTA
  //   const getPdfConsulta = async (path, file_name, setConstanciaDj) => {
  //     handlerLoading({ loading: true, loadName: "tabla" });
  //     const response = await axios().get(path);
  //     if (!isAxiosError(response)) {
  //       const { data, error } = response.data;
  //       if (data && !error) {
  //         setConstanciaDj(data);
  //         handlerModal({ modal: true, modalName: "constancia" });
  //       }
  //       if (!data && error) {
  //         toast.error(error, toastOptions);
  //       }
  //     } else {
  //       toast.error("Hubo un error en la consulta", toastOptions);
  //     }
  //     handlerLoading({ loading: false, loadName: "tabla" });
  //   };

  //TRAE TODA LAS LICENCIAS
  //   const getLicencias = async () => {
  //     handlerLoading({ loading: true, loadName: "licencias" });
  //     const response = await axios().get("dj/licencias");
  //     if (!isAxiosError(response)) {
  //       const { data, error } = response.data;
  //       if (data && !error) {
  //         setLicencias(data);
  //       }
  //       if (!data && error) {
  //         toast.error(error, toastOptions);
  //       }
  //     } else {
  //       toast.error("Hubo un erro en la consulta", toastOptions);
  //     }
  //     handlerLoading({ loading: false, loadName: "licencias" });
  //   };

  return {
    getActas,
    quitarNotificadorAsignado,
    asignarActasANotificador,
    getActaDetalle,
    getActaChequear,
    marcarActaImpresa,
    cambiarEstadoDescargo,
    buscarActa,
    anularActa,
    imprimirActas,
    generarActa,
    completarDatosDomicilio,
    marcarActaComoIncompleta,
    marcarActaComoAprobadoParaImprimir,
    generarConstancia,
    notificarActaDigital,
    notificarActa,
    /* , consultarEstado, generarRecibo, getPdfConsulta, getLicencias  */
  };
};

export default useActas;
